import AssessmentServer from '@/api/assessment'

export default {

    namespaced: true,

    state: {

        assessmentTreeInfo: [],

        //权重未到100的ID列表
        errorIds: [],

    },

    getters: {

        assessmentTreeInfo(state) {
            return state.assessmentTreeInfo;
        },

        errorIds(state) {
            return state.errorIds;
        },

    },

    mutations: {

        setAssessmentConfTreeInfo(state, payload) {
            state.assessmentTreeInfo = payload;
        },

        setErrorIds(state, payload) {
            state.errorIds = payload;
        },

    },

    actions: {

        getAssessmentConfTreeInfo({commit}, payload) {
            return new Promise((resolve, reject) => {
                AssessmentServer.assessmentConf.tree(payload).then((responseBody) => {
                    commit("setAssessmentConfTreeInfo", responseBody.data);
                });
            }).catch(error => {
                console.log('获取ASSESSMENTCONF配置信息失败');
                reject(error);
            });
        },


    },

}